module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight tabBox",
    attrs: {
      "id": "statusAlarmOffline"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus.home || _vm.loadingstatus.base || _vm.loadingstatus.mode || _vm.loadingstatus.period || _vm.loadingstatus.monitor),
      expression: "loadingstatus.home||loadingstatus.base||loadingstatus.mode||loadingstatus.period||loadingstatus.monitor"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alarm_process_icon"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.stepOneActive, 'finish': !_vm.stepOneActive && _vm.stepOneStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jibenxinxi"
  }), _c('span', [_vm._v("基本信息")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepTwoActive, 'finish': !_vm.stepTwoActive && _vm.stepTwoStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-baojingfangshi"
  }), _c('span', [_vm._v("报警方式")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepThreeActive, 'finish': !_vm.stepThreeActive && _vm.stepThreeStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongquyu"
  }), _c('span', [_vm._v("监控区域")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepFourActive, 'finish': !_vm.stepFourActive && _vm.stepFourStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongshiduan"
  }), _c('span', [_vm._v("监控时段")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepFiveActive, 'finish': !_vm.stepFiveActive && _vm.stepFiveStatus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiankongcheliang"
  }), _c('span', [_vm._v("监控车辆")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.stepSixActive
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-wancheng"
  }), _c('span', [_vm._v("完成")])])])])])]), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepOneActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanBase', {
    attrs: {
      "imageData": _vm.imgdata,
      "title": "车辆离线报警",
      "systemAlarms": "当车辆的定位设备发生离线，并超出约定的时限时，触发系统报警。",
      "bgClass": "alarm_list_bg07"
    },
    model: {
      value: (_vm.alarmBaseInfo),
      callback: function($$v) {
        _vm.alarmBaseInfo = $$v
      },
      expression: "alarmBaseInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepTwoActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanMode', {
    attrs: {
      "parentid": _vm.pageid
    },
    model: {
      value: (_vm.alarmModeInfo),
      callback: function($$v) {
        _vm.alarmModeInfo = $$v
      },
      expression: "alarmModeInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepThreeActive ? 'block' : 'none'
    })
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "0"
    },
    model: {
      value: (_vm.alarmAreaInfo.limitOf),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "limitOf", $$v)
      },
      expression: "alarmAreaInfo.limitOf"
    }
  }, [_vm._v("不限地域")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.alarmAreaInfo.limitOf),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "limitOf", $$v)
      },
      expression: "alarmAreaInfo.limitOf"
    }
  }, [_vm._v("仅限特定地域")])], 1)])])])]), _vm._v(" "), (_vm.alarmAreaInfo.limitOf == '0') ? _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-inline grey_box ofh pt10px",
    attrs: {
      "role": "form"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "0"
    },
    model: {
      value: (_vm.alarmAreaInfo.trigger),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "trigger", $$v)
      },
      expression: "alarmAreaInfo.trigger"
    }
  }, [_vm._v("立即触发")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.alarmAreaInfo.trigger),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "trigger", $$v)
      },
      expression: "alarmAreaInfo.trigger"
    }
  }, [_vm._v("车辆离线")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px mr30px",
    staticStyle: {
      "margin-top": "-6px"
    }
  }, [_c('input-number', {
    attrs: {
      "min": 0,
      "max": 100000,
      "controls": false,
      "inputWidth": 90,
      "disabled": _vm.onlimit
    },
    model: {
      value: (_vm.alarmAreaInfo.vehicleMinut),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "vehicleMinut", $$v)
      },
      expression: "alarmAreaInfo.vehicleMinut"
    }
  }), _vm._v(" "), _c('span', [_vm._v("分钟后")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.alarmAreaInfo.limitOf == '1' && _vm.mode != 2) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("电子围栏名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.alarmAreaInfo.alarmAreaParam.areaName),
      expression: "alarmAreaInfo.alarmAreaParam.areaName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.alarmAreaInfo.alarmAreaParam.areaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.alarmAreaInfo.alarmAreaParam, "areaName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(_vm.permission.indexOf('statusAlarmOffline_monitorAreaSelect') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fellInfoSearch
    }
  }, [_vm._v("查询")]) : _vm._e()])]), _vm._v(" "), (_vm.alarmAreaInfo.areaTipStatis) ? _c('p', {
    staticClass: "help-block focus_color"
  }, [_vm._v("未找到对应的电子围栏名称，请更换其它查询条件再试。")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-6 control-label gray t_left"
  }, [_vm._v("注：您可以通过“监控平台” --- “围栏”图标，建立新的电子围栏。")])])])]) : _vm._e(), _vm._v(" "), (_vm.alarmAreaInfo.areaStatis) ? _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-inline grey_box ofh pt10px",
    attrs: {
      "role": "form"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group pt5px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "0"
    },
    model: {
      value: (_vm.alarmAreaInfo.speciallyTrigger),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "speciallyTrigger", $$v)
      },
      expression: "alarmAreaInfo.speciallyTrigger"
    }
  }, [_vm._v("立即触发")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group pt5px"
  }, [_c('label', [_c('radio', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.alarmAreaInfo.speciallyTrigger),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "speciallyTrigger", $$v)
      },
      expression: "alarmAreaInfo.speciallyTrigger"
    }
  }, [_vm._v("车辆离线")])], 1)]), _vm._v(" "), _c('input-number', {
    attrs: {
      "min": 0,
      "max": 100000,
      "controls": false,
      "inputWidth": 90,
      "disabled": _vm.speciallyOnlimit
    },
    model: {
      value: (_vm.alarmAreaInfo.speciallyVehicleMinut),
      callback: function($$v) {
        _vm.$set(_vm.alarmAreaInfo, "speciallyVehicleMinut", $$v)
      },
      expression: "alarmAreaInfo.speciallyVehicleMinut"
    }
  }), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideFellInfo
    }
  }, [_vm._v("隐藏查询结果")])])]), _vm._v(" "), _c('table', {
    staticClass: "table mt20px table-striped table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.alarmAreaInfo.areaList), function(fileInfo, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(fileInfo.areaName))]), _vm._v(" "), _c('td', [(fileInfo.areaSize != 0) ? _c('span', [_vm._v(_vm._s(fileInfo.areaSize) + "㎡")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.createName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.createTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.memo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.permission.indexOf('statusAlarmOffline_monitorAreaAdd') == -1) ? _c('a', {
      staticClass: "text-center",
      on: {
        "click": function($event) {
          return _vm.addFellInfo(index)
        }
      }
    }, [_vm._v("添加")]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.alarmAreaInfo.areaList.length > 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.alarmAreaInfo.pageInfo
    },
    on: {
      "getData": _vm.getFellInfoPageNo
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.alarmAreaInfo.limitOf == '1') ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table mt20px table-striped table-bordered"
  }, [_c('thead', [_c('tr', [(_vm.mode != 2) ? _c('th') : _vm._e(), _vm._v(" "), _c('th', [_vm._v("电子围栏名称")]), _vm._v(" "), _c('th', [_vm._v("电子围栏面积")]), _vm._v(" "), _c('th', {
    staticClass: "focus_color"
  }, [_vm._v("触发敏感度")]), _vm._v(" "), _c('th', [_vm._v("围栏创建人")]), _vm._v(" "), _c('th', [_vm._v("围栏创建时间")]), _vm._v(" "), _c('th', [_vm._v("备注")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.alarmAreaInfo.areaAddList), function(fileInfo, index) {
    return _c('tr', {
      key: index
    }, [(_vm.mode != 2) ? _c('td', {
      staticClass: "text-center"
    }, [(_vm.permission.indexOf('statusAlarmOffline_monitorAreaDelete') == -1) ? _c('a', {
      staticClass: "text-center",
      on: {
        "click": function($event) {
          return _vm.removeFellInfo(index)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-trash"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.areaName))]), _vm._v(" "), _c('td', [(fileInfo.areaSize != 0) ? _c('span', [_vm._v(_vm._s(fileInfo.areaSize) + "㎡")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.triggerCount == 0 ? '立即' : fileInfo.triggerCount + '分钟'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.createName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.createTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.memo))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepFourActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanPeriod', {
    attrs: {
      "parentid": _vm.pageid
    },
    model: {
      value: (_vm.alarmPeriodInfo),
      callback: function($$v) {
        _vm.alarmPeriodInfo = $$v
      },
      expression: "alarmPeriodInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepFiveActive ? 'block' : 'none'
    })
  }, [_c('AlarmPlanMonitor', {
    attrs: {
      "typeid": _vm.typeid
    },
    model: {
      value: (_vm.alarmMonitorInfo),
      callback: function($$v) {
        _vm.alarmMonitorInfo = $$v
      },
      expression: "alarmMonitorInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.stepSixActive ? 'block' : 'none'
    })
  }, [_c('ul', _vm._l((_vm.checkList), function(item) {
    return _c('li', {
      staticClass: "focus_color"
    }, [_vm._v("\n\t\t\t\t    " + _vm._s(item.step + ':' + item.message) + "\n\t\t\t\t  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center pt10px"
  }, [(_vm.preBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button",
      "disabled": _vm.operStatus
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.nextBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.mode != 2 && _vm.finishBtnStatus) ? _c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button",
      "disabled": _vm.operStatus
    },
    on: {
      "click": _vm.saveAllInfo
    }
  }, [_vm._v(_vm._s(_vm.operStatus ? '保存完成' : '保存'))]) : _vm._e()])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 "
  }, [_c('div', {
    staticClass: "module_title"
  }, [_c('span', {
    staticClass: "focus_color"
  }, [_vm._v("请指定报警监控区域")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('div', {
    staticClass: "form-group pt5px mr30px"
  }, [_c('label', {
    staticClass: "focus_color"
  }, [_vm._v("报警范围")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('div', {
    staticClass: "form-group pt5px mr30px",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('label', {
    staticClass: "focus_color"
  }, [_vm._v("报警触发敏感度")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('div', {
    staticClass: "form-group pt5px"
  }, [_c('label', {
    staticClass: "focus_color"
  }, [_vm._v("区域触发敏感度")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v("分钟后")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("电子围栏名称")]), _vm._v(" "), _c('th', [_vm._v("电子围栏面积")]), _vm._v(" "), _c('th', [_vm._v("围栏创建人")]), _vm._v(" "), _c('th', [_vm._v("围栏创建时间")]), _vm._v(" "), _c('th', [_vm._v("备注")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3106a7b2","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclealarm/statusalarm/PageStatusAlarmOffline.vue
// module id = 1466
// module chunks = 0